<template>
  <v-layout row wrap>
    <v-flex xs6 md6>
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="itemActivo.FechaDesde"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            append-icon="event"
            label="Desde*"
            :value="iFechaDesde"
            :rules="rules"
            :readonly="true"
            clearable
            @click:clear="limpiarValorDesde"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="itemActivo.FechaDesde"
          no-title
          scrollable
          format="dd/mm/yyyy"
          locale="es-AR"
          :min="itemActivo.FechaMinima"
          :max="itemActivo.FechaMaxima"
          :readonly="readonly"
          :first-day-of-week="1"
          @input="seleccionarItem"
        >
          <v-spacer></v-spacer>
          <v-btn small text rounded @click="menu1 = false"
            >Cancelar
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn
            small
            rounded
            color="primary"
            @click="$refs.menu1.save(itemActivo.FechaDesde)"
            >Aceptar <v-icon right>check</v-icon></v-btn
          >
        </v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs6 md6>
      <v-menu
        ref="menu2"
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="itemActivo.FechaHasta"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            append-icon="event"
            label="Hasta*"
            :value="iFechaHasta"
            :rules="rules"
            :readonly="true"
            clearable
            @click:clear="limpiarValorHasta"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="itemActivo.FechaHasta"
          no-title
          scrollable
          format="dd/mm/yyyy"
          locale="es-AR"
          :min="itemActivo.FechaMinima"
          :max="itemActivo.FechaMaxima"
          :readonly="readonly"
          :first-day-of-week="1"
          @input="seleccionarItem"
        >
          <v-spacer></v-spacer>
          <v-btn small text rounded @click="menu2 = false"
            >Cancelar
            <v-icon right>clear</v-icon>
          </v-btn>
          <v-btn
            small
            rounded
            color="primary"
            @click="$refs.menu2.save(itemActivo.FechaHasta)"
            >Aceptar <v-icon right>check</v-icon></v-btn
          >
        </v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";
export default {
  name: "FechaRango",
  props: {
    fechaDesde: String,
    fechaHasta: String,
    rules: {},
    readonly: Boolean,
    sinFechaMinima: Boolean,
    sinFechaMaxima: Boolean,
    sinFechaSugerida: Boolean
  },
  data() {
    return {
      itemActivo: {
        FechaDesde: "",
        FechaHasta: "",
        FechaMinima: "",
        FechaMaxima: ""
      },
      // 1945-04-26
      //new Date().toISOString().substr(0, 10)
      menu1: false,
      menu2: false
    };
  },
  computed: {
    iFechaDesde() {
      return this.itemActivo.FechaDesde
        ? moment(this.itemActivo.FechaDesde)
            .locale("es-AR")
            .format("L")
        : "";
    },
    iFechaHasta() {
      return this.itemActivo.FechaHasta
        ? moment(this.itemActivo.FechaHasta)
            .locale("es-AR")
            .format("L")
        : "";
    }
  },
  created() {
    eventBus.$on("inicializarFecha", this.inicializar);
    this.inicializar();
  },
  mounted() {
    this.seleccionarItem();
  },
  beforeDestroy() {
    eventBus.$off("inicializarFecha", this.inicializar);
  },
  methods: {
    inicializar() {
      //mGuy: setear la fecha Desde con 1º día del mes actual.
      if (this.sinFechaSugerida) {
        this.itemActivo.FechaDesde =
          this.fechaDesde == "" ? new Date().toJSON() : this.fechaDesde;
        this.itemActivo.FechaHasta =
          this.fechaHasta == "" ? new Date().toJSON() : this.fechaHasta;
      } else {
        var fecha = new Date();
        fecha.setDate(1);
        fecha.setMonth(fecha.getMonth());
        this.itemActivo.FechaDesde = fecha.toJSON();
        this.itemActivo.FechaHasta = new Date().toJSON();
      }
      this.itemActivo.FechaMinima = this.sinFechaMinima
        ? null
        : new Date("1945-04-25").toJSON();
      this.itemActivo.FechaMaxima = this.sinFechaMaxima
        ? null
        : new Date().toJSON();
      this.$emit("seleccionarItem", this.itemActivo);
    },
    seleccionarItem() {
      this.$refs.menu1.save(this.itemActivo.FechaDesde);
      this.$refs.menu2.save(this.itemActivo.FechaHasta);
      this.$emit("seleccionarItem", this.itemActivo);
    },
    limpiarValorDesde() {
      this.itemActivo.FechaDesde = null;
      this.seleccionarItem();
    },
    limpiarValorHasta() {
      this.itemActivo.FechaHasta = null;
      this.seleccionarItem();
    }
  }
};
</script>
